import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_BEGIN,
  PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_SUCCESS,
  PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_FAILURE,
  PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_DISMISS_ERROR,
} from './constants';

export function loadEncryptInstalledPluginDetail(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_BEGIN,
    });

    const { projectId, version, installedPluginId } = args;
    console.log('These are the args: ', args);
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/plugins/encrypt`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_SUCCESS,
            data: res.data.setting ? res.data.setting : '',
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });
    return promise;
  };
}

export function dismissLoadEncryptInstalledPluginDetailError() {
  return {
    type: PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_BEGIN:
      return {
        ...state,
        loadEncryptInstalledPluginDetailPending: true,
        loadEncryptInstalledPluginDetailError: null,
      };

    case PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_SUCCESS:
      return {
        ...state,
        loadEncryptInstalledPluginDetailPending: false,
        loadEncryptInstalledPluginDetailError: null,
      };

    case PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_FAILURE:
      return {
        ...state,
        loadEncryptInstalledPluginDetailPending: false,
        loadEncryptInstalledPluginDetailError: action.data.error,
      };

    case PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_DISMISS_ERROR:
      return {
        ...state,
        loadEncryptInstalledPluginDetailError: null,
      };

    default:
      return state;
  }
}
